/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for ensuring a reservationless practice session for this task.
 */
export interface OralExamPracticeEnsureRequest {
  taskId: string;
}
